module.exports = __webpack_public_path__ + "img/DE01308.605e71b1.png";